import { useState } from 'react';
import { useAddForceSync } from '.';
import getDefaultGridState from '../../../core/types/common/DefaultGridState';
import { useToastify } from '../../../../Hooks';

export enum ETriggerResponse {
    AlreadyRunning = 1,
    Ok,
    AlreadyTriggered,
    NotFound,
    NotConfigurationFound,
}

const useForceSync = () => {
    const [forceSyncDialogActive, setForceSyncDialogActive] = useState(false);

    const { addForceSyncMutation } = useAddForceSync();
    const { showToastError, showToastSuccess, showToastWarning } = useToastify();

    const handleOnClick = ( setGridState?: any) => {
        addForceSyncMutation.mutate(undefined, {
            onError: (error: any) => {
                const { config, status } = error?.response;
                switch (status) {
                    case 409:
                        showToastWarning(`A full sync already running.`);
                        break;
                    default:
                        break;
                }
                
            },
            onSuccess: (result) => {
                console.log('result', result);
                if(result.status == 200){
                    showToastSuccess(`A full sync has been triggered!`);
                    if (setGridState !== undefined) {
                        setGridState(getDefaultGridState());
                    }
                    
                }
                else if (result.status == 409) {
                    showToastWarning(`A full sync has already been triggered.`);
                }
                setForceSyncDialogActive(!forceSyncDialogActive);
            },
        });
    };
    return { handleOnClick, forceSyncDialogActive, setForceSyncDialogActive };
};

export default useForceSync;
